import { lazy } from 'react';
import { Loadable } from '@planitgeo/treeplotter-ui-library';
import { loadableFallback } from 'utils/loadableFallback';

export const Home = Loadable(
  lazy(() => import('identityAndAccess/presentation/home/Home')),
  loadableFallback
);

export const LoginPage = Loadable(
  lazy(() => import('identityAndAccess/presentation/login/LoginPage')),
  loadableFallback
);
export const AwsCognitoCallbackPage = Loadable(
  lazy(() => import('identityAndAccess/presentation/login/AwsCognitoCallbackPage')),
  loadableFallback
);
